import { call, put, takeLatest } from 'redux-saga/effects';
import { DELETE_ASSET_REQUEST } from './constants';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { notify } from 'sharedComponents/GeneralNotification';
import { actionTypes } from '../../../constants';
import { getAssetDeleteAction } from './actions';
function* deleteAssetSaga(action) {
    yield put(getAssetDeleteAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.deleteGatewayAsset, action.assetId);
        if (response?.success) {
            yield put(getAssetDeleteAction(apiCallStatus.SUCCESS));
            notify(translate('ABB.Powertrain.Frontend.AssetDeletedSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        } else if (response?.error) {
            notify(response?.error?.message, NOTIFICATION_TYPES.ERROR, true);
        }
        yield put({
            type: actionTypes.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: action.gatewayId }
        });
        // Call the reset asset info callback if provided
        if (typeof action.onResetAssetInfo === 'function') {
            yield call(action.onResetAssetInfo);
        }

    } catch (error) {
        yield put(getAssetDeleteAction(apiCallStatus.ERROR, [], error));
    }
}
export function* watchDeleteAsset() {
    yield takeLatest(DELETE_ASSET_REQUEST, deleteAssetSaga);
}
